import { wrapDatadogReplayTitle } from '@act/storybook';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, IconButton, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { generateDatadogTrackingProps } from 'toolkit/environment/environment/userMonitoring.util';

interface CloseableDialogTitleProps {
  title: ReactNode;
  handleClose: () => void;
}

const CloseableDialogTitle = ({
  title,
  handleClose,
}: CloseableDialogTitleProps) => {
  return (
    <DialogTitle
      sx={{
        width: '600px',
        boxSizing: 'border-box',
      }}
    >
      <Typography component="div" variant="titleLarge">
        {wrapDatadogReplayTitle(title)}
      </Typography>
      <IconButton {...generateDatadogTrackingProps('closeable-dialog-title-icon-button-close')}
        aria-label="close form dialog"
        onClick={handleClose}
        sx={{
          position: 'absolute !important',
          right: '16px',
          top: '12px',
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default CloseableDialogTitle;
